import React from 'react';
import { Link } from 'gatsby';

import SEO from '../components/seo';
import Header from '../components/Header';
import Footer from '../components/Footer';

import '../components/layout.css';

const ContactPage = () => (
  <div className="theme-default bg-background text-foreground">
    <SEO title="Contact" />
    <Header />

    <main>
      {/* OCF secondaryHero */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <span className="chip mb-6 inline-flex">Get in touch</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight tracking-tight mt-4">
            Contact
          </h1>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: contact info */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">Reach us</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="bg-background-raised rounded border border-border p-6">
                  <div className="font-mono text-sm text-muted-foreground mb-2">
                    Email
                  </div>
                  <a
                    href="mailto:contact@longstrawcarbon.com"
                    className="text-base leading-relaxed underline hover:text-accent"
                  >
                    contact@longstrawcarbon.com
                  </a>
                </div>
                <div className="bg-background-raised rounded border border-border p-6">
                  <div className="font-mono text-sm text-muted-foreground mb-2">
                    Isometric registry
                  </div>
                  <a
                    href="https://registry.isometric.com/project/6PQZ"
                    className="text-base leading-relaxed underline hover:text-accent"
                  >
                    Project 6PQZ
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: purpose */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">For procurement &amp; investors</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="prose prose-lg max-w-none">
                <p>
                  For carbon removal procurement desks, institutional investors,
                  and independent diligence rating agencies seeking technical
                  diligence packages, please reach out via email.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default ContactPage;
